"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
function getAccountTree(accountId, testData) {
    return __awaiter(this, void 0, void 0, function () {
        var url, res, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (testData) {
                        return [2 /*return*/, {
                                data: {
                                    children: [
                                        { name: " MS Teams Licence Test", id: "39621", parentId: "1005" },
                                        { name: "010101test", id: "35497", parentId: "1005" },
                                        { name: "0101test", id: "35496", parentId: "1005" },
                                        { name: "9585test 1.14.", id: "34894", parentId: "1005" },
                                        { name: "A1QA", id: "18566", parentId: "1005" },
                                        { name: "Account20170518", id: "30574", parentId: "1005" },
                                        { name: "accounttomove", id: "27338", parentId: "1005" },
                                        {
                                            name: "Add account without product test under 1005",
                                            id: "37948",
                                            parentId: "1005"
                                        },
                                        { name: "Agent Ready", id: "22578", parentId: "1005" },
                                        { name: "Aurora Test", id: "20553", parentId: "1005" },
                                        { name: "Call_host_Test", id: "30521", parentId: "1005" },
                                        { name: "Charlie Test", id: "40303", parentId: "1005" },
                                        {
                                            children: [
                                                { name: "SIP Customer 1", id: "37175", parentId: "37174" },
                                                { name: "SIP Customer 2", id: "37179", parentId: "37174" },
                                                { name: "SIP Customer 3", id: "37180", parentId: "37174" }
                                            ],
                                            name: "Churchills War Room",
                                            id: "37174",
                                            parentId: "1005"
                                        },
                                        { name: "Conferencing", id: "22947", parentId: "1005" },
                                        { name: "d", id: "24162", parentId: "1005" },
                                        { name: "Darren Hosted Test", id: "32207", parentId: "1005" },
                                        { name: "Dave Bessell Test", id: "40216", parentId: "1005" },
                                        {
                                            name: "Developer Live Test account",
                                            id: "30520",
                                            parentId: "1005"
                                        },
                                        { name: "E2E TEST WARNING 2 !!!", id: "32957", parentId: "1005" },
                                        { name: "E2E TEST WARNING!!!", id: "32788", parentId: "1005" },
                                        { name: "Elliott Test container", id: "40590", parentId: "1005" },
                                        { name: "Empirix Test Account", id: "40571", parentId: "1005" },
                                        { name: "Empty", id: "24673", parentId: "1005" },
                                        {
                                            name: "empty account no permissions",
                                            id: "24849",
                                            parentId: "1005"
                                        },
                                        { name: "Fantasy iTeam (MoVo)", id: "23501", parentId: "1005" },
                                        {
                                            name: "Fifthcomm Quarantined Numbers",
                                            id: "27197",
                                            parentId: "1005"
                                        },
                                        {
                                            children: [
                                                { name: "Submarine Account", id: "35925", parentId: "35330" }
                                            ],
                                            name: "GarethPrince",
                                            id: "35330",
                                            parentId: "1005"
                                        },
                                        {
                                            children: [{ name: "1", id: "35795", parentId: "35334" }],
                                            name: "GarethPrinceIE",
                                            id: "35334",
                                            parentId: "1005"
                                        },
                                        { name: "GSF-Test", id: "37754", parentId: "1005" },
                                        { name: "host.vinit.host", id: "33119", parentId: "1005" },
                                        { name: "Host_final_testing", id: "30542", parentId: "1005" },
                                        { name: "host_test", id: "30512", parentId: "1005" },
                                        { name: "Host_Testing", id: "30518", parentId: "1005" },
                                        { name: "Hosted Live Licences", id: "34584", parentId: "1005" },
                                        { name: "Hosted test", id: "34958", parentId: "1005" },
                                        { name: "Hosted Testing account", id: "34227", parentId: "1005" },
                                        { name: "Hosted-test", id: "34984", parentId: "1005" },
                                        { name: "Hostinvo", id: "30760", parentId: "1005" },
                                        { name: "hostinvo123", id: "30763", parentId: "1005" },
                                        { name: "Hots_testing2", id: "30553", parentId: "1005" },
                                        { name: "Inbound Testing Account", id: "34228", parentId: "1005" },
                                        { name: "Invohost", id: "30759", parentId: "1005" },
                                        { name: "Invohost1234", id: "30783", parentId: "1005" },
                                        { name: "invohost456", id: "30774", parentId: "1005" },
                                        { name: "Invosys", id: "20336", parentId: "1005" },
                                        { name: "John test", id: "28050", parentId: "1005" },
                                        { name: "LambdaTest Demo", id: "40592", parentId: "1005" },
                                        { name: "Live test", id: "32588", parentId: "1005" },
                                        { name: "live test125", id: "33348", parentId: "1005" },
                                        { name: "Missed Call Test", id: "29189", parentId: "1005" },
                                        { name: "Monitoring", id: "32024", parentId: "1005" },
                                        {
                                            children: [
                                                { name: "Statements Only Test", id: "40111", parentId: "37285" },
                                                { name: "Test", id: "38997", parentId: "37285" }
                                            ],
                                            name: "Nick Test",
                                            id: "37285",
                                            parentId: "1005"
                                        },
                                        { name: "nm.4.15", id: "34874", parentId: "1005" },
                                        { name: "nm1_14_1", id: "34882", parentId: "1005" },
                                        { name: "NM_1.15", id: "34885", parentId: "1005" },
                                        { name: "no email", id: "26951", parentId: "1005" },
                                        {
                                            children: [
                                                { name: "Number Manager 4.9.1", id: "33364", parentId: "33357" }
                                            ],
                                            name: "Number Manager 4.9",
                                            id: "33357",
                                            parentId: "1005"
                                        },
                                        { name: "Product Demo Account ST", id: "37172", parentId: "1005" },
                                        {
                                            name: "replication hosted licence test",
                                            id: "34996",
                                            parentId: "1005"
                                        },
                                        { name: "Replication Nov-19", id: "37371", parentId: "1005" },
                                        {
                                            children: [
                                                { name: "Paul D Test Account", id: "38695", parentId: "36788" }
                                            ],
                                            name: "Rob S SIP Demo",
                                            id: "36788",
                                            parentId: "1005"
                                        },
                                        { name: "Sip Testing Account", id: "34229", parentId: "1005" },
                                        { name: "Sip Testing Issue", id: "35948", parentId: "1005" },
                                        {
                                            children: [
                                                { name: "Marker Study Conf Demo", id: "35820", parentId: "35818" }
                                            ],
                                            name: "Siraz",
                                            id: "35818",
                                            parentId: "1005"
                                        },
                                        { name: "Stephen Test SIP Enhanced", id: "32592", parentId: "1005" },
                                        { name: "Stuart Test", id: "37764", parentId: "1005" },
                                        {
                                            children: [
                                                {
                                                    name: "alert(\u0027Hello new user\u0027);",
                                                    id: "24165",
                                                    parentId: "2514"
                                                },
                                                { name: "Sub Sub", id: "2844", parentId: "2514" }
                                            ],
                                            name: "Sub",
                                            id: "2514",
                                            parentId: "1005"
                                        },
                                        { name: "Supplier Test Account", id: "33248", parentId: "1005" },
                                        { name: "tanya no email2", id: "26949", parentId: "1005" },
                                        { name: "TEST", id: "19567", parentId: "1005" },
                                        { name: "Test 06", id: "34895", parentId: "1005" },
                                        { name: "test 1.14.", id: "34892", parentId: "1005" },
                                        { name: "test 1.14.8", id: "34893", parentId: "1005" },
                                        { name: "TEST ACC", id: "15978", parentId: "1005" },
                                        { name: "TEST AP 15SEPT", id: "15659", parentId: "1005" },
                                        { name: "TEST BILLING", id: "3677", parentId: "1005" },
                                        { name: "Test Host", id: "33872", parentId: "1005" },
                                        {
                                            name: "Test Hosted Client - Andy test account",
                                            id: "32790",
                                            parentId: "1005"
                                        },
                                        { name: "test new account", id: "15658", parentId: "1005" },
                                        { name: "Test.Pass", id: "33873", parentId: "1005" },
                                        { name: "test26 ", id: "35329", parentId: "1005" },
                                        { name: "Test4.15.2", id: "34964", parentId: "1005" },
                                        { name: "test_site_viewe", id: "34699", parentId: "1005" },
                                        { name: "testetstetse", id: "34959", parentId: "1005" },
                                        { name: "testing 01", id: "34983", parentId: "1005" },
                                        { name: "Testing Enterprise account", id: "28105", parentId: "1005" },
                                        {
                                            children: [
                                                { name: "Hosted Test Booth", id: "34657", parentId: "29829" },
                                                { name: "Hosted Test Booth 2", id: "35633", parentId: "29829" }
                                            ],
                                            name: "Testing Scenarios",
                                            id: "29829",
                                            parentId: "1005"
                                        },
                                        { name: "Testing stat", id: "34977", parentId: "1005" },
                                        { name: "Testing stat01", id: "34995", parentId: "1005" },
                                        { name: "Testing Sub Account", id: "37156", parentId: "1005" },
                                        { name: "User Guide SIP Trunk", id: "33519", parentId: "1005" },
                                        { name: "Yeastar SIP Testing", id: "37364", parentId: "1005" }
                                    ],
                                    name: "5thComm (Test)",
                                    id: "1005"
                                },
                                page_size: 1,
                                status: "success"
                            }];
                    }
                    url = "/nm-api/api/account/" + accountId + "/children";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(url, {
                            headers: {
                                "content-type": "application/json"
                            },
                            method: "GET",
                            credentials: "include"
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3: return [2 /*return*/, _a.sent()];
                case 4:
                    err_1 = _a.sent();
                    return [2 /*return*/, "Error: " + err_1];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.default = getAccountTree;
